// extracted by mini-css-extract-plugin
module.exports = {"featuredLocation":"FeaturedLocation_featuredLocation__2Zaw-"};